<script>
export default {
  props: {
    step: {
      type: Number,
      default: 1,
    },
    steps: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<template>
  <div class="plantao-stepper mb-4">
    <div class="d-flex align-items-start justify-content-between">
      <div
        v-for="(item, index) in steps"
        :key="index"
        class="plantao-stepper-item"
        :class="{ done: index + 1 < step, current: index + 1 === step }"
      >
        <div class="plantao-stepper-circle">
          <svg v-if="index + 1 < step" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" style="fill: #fff;">
            <path d="m10 15.586-3.293-3.293-1.414 1.414L10 18.414l9.707-9.707-1.414-1.414z"></path>
          </svg>
          <span v-else>{{ index + 1 }}</span>
        </div>
        <div class="plantao-stepper-label d-none d-md-block">{{ item }}</div>
      </div>
    </div>
    <div class="d-md-none text-center mt-2 text-muted font-size-13">
      Etapa {{ step }} de {{ steps.length }} · <strong>{{ steps[step - 1] }}</strong>
    </div>
  </div>
</template>

<style scoped>
.plantao-stepper-item {
  flex: 1;
  position: relative;
  text-align: center;
}
.plantao-stepper-item:not(:last-child)::after {
  content: "";
  position: absolute;
  top: 17px;
  left: calc(50% + 22px);
  right: calc(-50% + 22px);
  height: 2px;
  background: #e1e2ea;
}
.plantao-stepper-item.done:not(:last-child)::after {
  background: rgb(53, 195, 147);
}
.plantao-stepper-circle {
  width: 36px;
  height: 36px;
  margin: 0 auto;
  border-radius: 50%;
  border: 2px solid #e1e2ea;
  background: #fff;
  color: #9a9bb0;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
}
.plantao-stepper-item.current .plantao-stepper-circle {
  border-color: #343a40;
  color: #343a40;
}
.plantao-stepper-item.done .plantao-stepper-circle {
  border-color: rgb(53, 195, 147);
  background: rgb(53, 195, 147);
}
.plantao-stepper-label {
  margin-top: 6px;
  font-size: 13px;
  color: #9a9bb0;
}
.plantao-stepper-item.current .plantao-stepper-label {
  color: #343a40;
  font-weight: 600;
}
</style>
